import { useRef, useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TextField, Button, MenuItem } from "@mui/material";
import axios from "axios";
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { API, MSG } from "./constantsFront";
import { MsgContext } from "../../App";

/**
 * 輸出相手国登録・変更
 * @returns 
 */
function G0192ExportCountryEdit() {
  const [countryCode, setCountryCode] = useState(""); // 国コード
  const [countryName, setCountryName] = useState(""); // 国名
  const [countryKana, setCountryKana] = useState(""); // カナ名
  const [countryNameEn, setCountryNameEn] = useState(""); // 英語名
  const [countryName3, setCountryName3] = useState(""); // 国名コード3
  const [countryName2, setCountryName2] = useState(""); // 国名コード2
  const [areaCode, setAreaCode] = useState(""); // 地域コード
  const [iso, setIso] = useState(""); // 各行政区分

  //必須チェック用メッセージ
  const [countryCodeMsg, setCountryCodeMsg] = useState(""); // (国コード)
  const [countryNameMsg, setCountryNameMsg] = useState(""); // (国名)
  const [countryKanaMsg, setCountryKanaMsg] = useState(""); // (カナ名)
  const [countryNameEnMsg, setCountryNameEnMsg] = useState(""); // (英語名)
  // const [countryName3Msg, setCountryName3Msg] = useState(""); // (国名コード3)
  // const [countryName2Msg, setCountryName2Msg] = useState(""); // (国名コード2)
  const [areaCodeMsg, setAreaCodeMsg] = useState(""); // (地域)
  // const [isoMsg, setIsoMsg] = useState(""); // (各行政区分)

  const [areaList, setAreaList] = useState([]); // 地域
  const [ECMain, setECMain] = useState(""); // Edit画面表題
  const [jaIniList, setJaIniList] = useState(""); // 和名頭文字リスト

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  const navigate = useNavigate();

  let body = { authKey: API.API_KEY };

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  const location = useLocation();
  let selectCountryCode = "";

  if (location.state != null) {
    selectCountryCode = location.state.countryCode;
    window.localStorage.setItem("selectCountryCode", selectCountryCode); // ローカルストレージに保存する
  } else {
    selectCountryCode = window.localStorage.getItem("selectCountryCode"); // ローカルストレージから取り出す
  }

  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    // 和名頭文字リスト
    axios.post("/m_rac_ja_initials/select/auth", body).then(res => {
      // 取得チェック
      if (res.status != 200) {
        return;
      }
      setJaIniList(res.data.dataList);
    });

    axios.post("/m_area/select/auth", body).then(res => {
      // 取得チェック
      if (res.status != 200) {
        return;
      }
      setAreaList(res.data.dataList);
    });

    if (selectCountryCode == -1) {
      setECMain("輸出相手国新規登録");
    } else {
      getStaff();
      setECMain("輸出相手国編集");
    }

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;

  }, [])

  // 更新履歴取得
  async function getStaff() {
    body.countryCode = selectCountryCode;
    await axios.post("/m_export_country/select/auth", body).then(res => {
      // 取得チェック
      if (res.status != 200) {
        return;
      }

      let ECList = res.data.dataList;
      setCountryCode(selectCountryCode);
      setCountryName(ECList[0].country_name);
      setCountryKana(ECList[0].country_kana);
      setCountryNameEn(ECList[0].country_name_en);
      setCountryName3(ECList[0].country_name3);
      setCountryName2(ECList[0].country_name2);
      setAreaCode(ECList[0].area_code);
      setIso(ECList[0].iso);
    }).catch(error => {
      console.log('error:', error);
      setMsg(MSG.EXCEPTION);
    });
  }

  // 保存処理
  async function register() {
    let jaInitials = "";
    try {
      if (!countryCode) {
        setCountryCodeMsg("国コードは必須です");
      } else {
        setCountryCodeMsg("");
      }
      if (!countryName) {
        setCountryNameMsg("国名は必須です");
      } else {
        setCountryNameMsg("");
      }
      if (!countryKana) {
        setCountryKanaMsg("カナ名は必須です");
      } else {
        setCountryKanaMsg("");

        // 五十音
        jaInitials = cngFirstLetter(countryKana.slice(0, 1));
        if (!jaInitials) {
          setCountryKanaMsg("カナ名が不正です");
        }
      }
      if (!countryNameEn) {
        setCountryNameEnMsg("英語名は必須です");
      } else {
        setCountryNameEnMsg("");
      }
      // if (!countryName3) {
      //   setCountryName3Msg("国名コード3は必須です");
      // } else {
      //   setCountryName3Msg("");
      // }
      // if (!countryName2) {
      //   setCountryName2Msg("国名コード2は必須です");
      // } else {
      //   setCountryName2Msg("");
      // }
      if (!areaCode) {
        setAreaCodeMsg("地域は必須です");
      } else {
        setAreaCodeMsg("");
      }
      // if (!iso) {
      //   setIsoMsg("各行政区分は必須です");
      // } else {
      //   setIsoMsg("");
      // }

      // if (!(countryCode && countryName && countryKana && jaInitials && countryNameEn && countryName3 && countryName2 && areaCode && iso)) {
      if (!(countryCode
        && countryName
        && countryKana
        && jaInitials
        && countryNameEn
        && areaCode)) {
        return;
      }

      body.countryCode = countryCode;
      if (selectCountryCode == -1) {
        const res2 = await axios.post("/m_export_country/select/auth", body);
        // 取得チェック
        if (res2.status != 200) {
          return;
        }
        if (res2.data.dataList.length != 0) {
          return setCountryCodeMsg("入力した国コードが既に存在します");
        }

        const res = await axios.post("/m_synonym_country/max_synonym_id/auth", body);
        // 取得チェック
        if (res.status != 200) {
          return;
        }
        let synonymId = 0;
        if (res.data.dataList.length != 0) {
          synonymId = Number(res.data.dataList[0].synonym_id) + 1;
        }
        body.synonymId = synonymId;
      }

      body.countryName = countryName;
      body.countryKana = countryKana;
      body.jaInitials = jaInitials;
      body.countryNameEn = countryNameEn;
      body.countryName3 = countryName3;
      body.countryName2 = countryName2;
      body.areaCode = areaCode;
      body.iso = iso;


      // insertとupdateを分岐させる
      if (selectCountryCode == -1) {
        // insert
        const res = await axios.post("/m_export_country/insert_multiple/auth", body);
        // 取得チェック
        if (res.status != 200) {
          return;
        }
        console.log("insert成功");
        window.location.href = "./G0191ExportCountryList";
        alert("登録が完了しました。");
      } else {
        // update
        const res2 = await axios.post("/m_export_country/update_multiple/auth", body);
        // 取得チェック
        if (res2.status != 200) {
          return;
        }

        console.log("insert成功");
        window.location.href = "./G0191ExportCountryList";
        alert("登録が完了しました。");
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  var kanaArr = {
    "ア行": 'アイウエオ',
    "カ行": 'カキクケコガギグゲゴ',
    "サ行": 'サシスセソザジズゼゾ',
    "タ行": 'タチツテトダヂヅデド',
    "ナ行": 'ナニヌネノ',
    "ハ行": 'ハヒフヘホパピプペポバビブベボ',
    "マ行": 'マミムメモ',
    "ヤ行": 'ヤユヨ',
    "ラ行": 'ラリルレロ',
    "ワ行": 'ワヲン',
  };

  // カナ名から五十音を取得する
  function cngFirstLetter(kanaData) {
    var reKey = "";
    var key = Object.keys(kanaArr); // 例：ア行
    var data = Object.values(kanaArr); // 例：アイウエオ

    for (let i in data) {
      if (data[i].indexOf(kanaData) >= 0) {
        reKey = key[i];
      }
    }

    return reKey;
  }

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg">
                <Stack spacing={2}>

                  <h1>{ECMain}</h1>
                  <TextField id="countryCode" variant="outlined" value={countryCode}
                    label="国コード"
                    required
                    disabled={(selectCountryCode != -1) ? true : false}
                    inputProps={{
                      maxLength: 20,
                    }}
                    error={Boolean(countryCodeMsg == "" ? false : true)}
                    helperText={countryCodeMsg}
                    onChange={e => { setCountryCode(e.target.value) }} />

                  <TextField id="countryName" variant="outlined" value={countryName}
                    label="国名"
                    required
                    error={Boolean(countryNameMsg == "" ? false : true)}
                    helperText={countryNameMsg}
                    onChange={e => { setCountryName(e.target.value) }} />

                  <TextField id="countryKana" variant="outlined" value={countryKana}
                    label="カナ名"
                    required
                    error={Boolean(countryKanaMsg == "" ? false : true)}
                    helperText={countryKanaMsg}
                    onChange={e => { setCountryKana(e.target.value) }} />

                  <TextField id="countryNameEn" variant="outlined" value={countryNameEn}
                    label="英語名"
                    required
                    error={Boolean(countryNameEnMsg == "" ? false : true)}
                    helperText={countryNameEnMsg}
                    onChange={e => { setCountryNameEn(e.target.value) }} />

                  <TextField id="countryName3" variant="outlined" value={countryName3}
                    label="国名コード3"
                    // required
                    // error={Boolean(countryName3Msg == "" ? false : true)}
                    // helperText={countryName3Msg}
                    onChange={e => { setCountryName3(e.target.value) }} />

                  <TextField id="countryName2" variant="outlined" value={countryName2}
                    label="国名コード2"
                    // required
                    // error={Boolean(countryName2Msg == "" ? false : true)}
                    // helperText={countryName2Msg}
                    onChange={e => { setCountryName2(e.target.value) }} />

                  <TextField id="areaCode" variant="outlined" value={areaCode}
                    label="地域"
                    required
                    select
                    error={Boolean(areaCodeMsg == "" ? false : true)}
                    helperText={areaCodeMsg}
                    // onChange={e => { console.log(e.target.value) }} >
                    onChange={e => { setAreaCode(e.target.value) }}
                  >
                    {areaList.map((option) => (
                      <MenuItem key={option.area_code} value={option.area_code}>
                        {option.area_name}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField id="iso" variant="outlined" value={iso}
                    label="各行政区分"
                    // required
                    // error={Boolean(isoMsg == "" ? false : true)}
                    // helperText={isoMsg}
                    onChange={e => { setIso(e.target.value) }} />

                  <Stack spacing={2} direction="row">
                    <Button href="./G0191ExportCountryList"
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      戻る
                    </Button>
                    <Button onClick={register} style={{ width: "200px" }}>登録</Button>
                  </Stack>

                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default G0192ExportCountryEdit;